export default {
  FETCH_ALL_DISCOUNT_CODES_SUCCESS: 'FETCH_ALL_DISCOUNT_CODES_SUCCESS',
  FETCH_ALL_DISCOUNT_CODES_LOADING: 'FETCH_ALL_DISCOUNT_CODES_LOADING',
  FETCH_ALL_DISCOUNT_CODES_REJECT: 'FETCH_ALL_DISCOUNT_CODES_REJECT',
  FETCH_ALL_DISCOUNT_CODES_FAILED: 'FETCH_ALL_DISCOUNT_CODES_FAILED',


  FETCH_DISCOUNT_CODE_BY_ID_SUCCESS: 'FETCH_DISCOUNT_CODE_BY_ID_SUCCESS',
  FETCH_DISCOUNT_CODE_BY_ID_LOADING: 'FETCH_DISCOUNT_CODE_BY_ID_LOADING',
  FETCH_DISCOUNT_CODE_BY_ID_REJECT: 'FETCH_DISCOUNT_CODE_BY_ID_REJECT',
  FETCH_DISCOUNT_CODE_BY_ID_FAILED: 'FETCH_DISCOUNT_CODE_BY_ID_FAILED',


  INSERT_NEW_DISCOUNT_CODE_SUCCESS: 'INSERT_NEW_DISCOUNT_CODE_SUCCESS',
  INSERT_NEW_DISCOUNT_CODE_LOADING: 'INSERT_NEW_DISCOUNT_CODE_LOADING',
  INSERT_NEW_DISCOUNT_CODE_REJECT: 'INSERT_NEW_DISCOUNT_CODE_REJECT',
  INSERT_NEW_DISCOUNT_CODE_FAILED: 'INSERT_NEW_DISCOUNT_CODE_FAILED',


  UPDATE_DISCOUNT_CODE_SUCCESS: 'UPDATE_DISCOUNT_CODE_SUCCESS',
  UPDATE_DISCOUNT_CODE_LOADING: 'UPDATE_DISCOUNT_CODE_LOADING',
  UPDATE_DISCOUNT_CODE_REJECT: 'UPDATE_DISCOUNT_CODE_REJECT',
  UPDATE_DISCOUNT_CODE_FAILED: 'UPDATE_DISCOUNT_CODE_FAILED',


  UPDATE_DISCOUNT_CODE_STATUS_SUCCESS: 'UPDATE_DISCOUNT_CODE_STATUS_SUCCESS',
  UPDATE_DISCOUNT_CODE_STATUS_LOADING: 'UPDATE_DISCOUNT_CODE_STATUS_LOADING',
  UPDATE_DISCOUNT_CODE_STATUS_REJECT: 'UPDATE_DISCOUNT_CODE_STATUS_REJECT',
  UPDATE_DISCOUNT_CODE_STATUS_FAILED: 'UPDATE_DISCOUNT_CODE_STATUS_FAILED',


  CREATE_RANDOM_DISCOUNT_CODE_SUCCESS: 'CREATE_RANDOM_DISCOUNT_CODE_SUCCESS',
  CREATE_RANDOM_DISCOUNT_CODE_LOADING: 'CREATE_RANDOM_DISCOUNT_CODE_LOADING',
  CREATE_RANDOM_DISCOUNT_CODE_REJECT: 'CREATE_RANDOM_DISCOUNT_CODE_REJECT',
  CREATE_RANDOM_DISCOUNT_CODE_FAILED: 'CREATE_RANDOM_DISCOUNT_CODE_FAILED',


  SPECIAL_SEARCHED_USERS_SUCCESS: 'SPECIAL_SEARCHED_USERS_SUCCESS',
  SPECIAL_SEARCHED_USERS_LOADING: 'SPECIAL_SEARCHED_USERS_LOADING',
  SPECIAL_SEARCHED_USERS_REJECT: 'SPECIAL_SEARCHED_USERS_REJECT',
  SPECIAL_SEARCHED_USERS_FAILED: 'SPECIAL_SEARCHED_USERS_FAILED',


  DISCOUNT_CODE_USERS_SUCCESS: 'DISCOUNT_CODE_USERS_SUCCESS',
  DISCOUNT_CODE_USERS_LOADING: 'DISCOUNT_CODE_USERS_LOADING',
  DISCOUNT_CODE_USERS_REJECT: 'DISCOUNT_CODE_USERS_REJECT',
  DISCOUNT_CODE_USERS_FAILED: 'DISCOUNT_CODE_USERS_FAILED',

}